// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-l_fG","catalogByServiceItem__title":"c-l_fH"};